import React from "react";
import ManageBookings from "./ManageBookings";

const ManageNewBookings = () => {
    return (<ManageBookings bookingStatus='NEW' title='New Bookings'/>)
}

export default ManageNewBookings;
